export enum RegisteredEventName {
  action = 'action',
  changeViewport = 'changeViewport',
  changeNavigation = 'changeNavigation',
  createLead = 'createLead',
  scrollTo = 'scrollTo',
  backLink = 'backLink',
  scrollTop = 'scrollTop',
  ready = 'ready',
  setOptOut = 'setOptOut',
  setCurrentNavigation = 'setCurrentNavigation',
  getCurrentNavigation = 'getCurrentNavigation',
  updateCurrentImodTraversal = 'updateCurrentImodTraversal',
  setParentStorage = 'setParentStorage', // don't know where it is used so not touching it
  tracking = 'tracking',
  cookieConsentChange = 'cookieConsentChange',
  openDialog = 'openDialog',
  redirect = 'redirect',
  getParentFrameUrl = 'getParentFrameUrl',
  setParentFrameUrl = 'setParentFrameUrl',
  dialogClosed = 'dialogClosed',
  deleteCookie = 'deleteCookie',
  getParentStorage = 'getParentStorage',
  trackPageVisit = 'trackPageVisit',
  setParentStorageData = 'setParentStorageData',
  getTenantContext = 'getTenantContext',
  parentFrameStartLoadDate = 'parentFrameStartLoadDate',
  getIsEmailFieldDisabled = 'getIsEmailFieldDisabled',
  callSegmentIdentify = 'callSegmentIdentify',
  updateQueryParams = 'updateQueryParams',
  openWindow = 'openWindow'
}

export interface EventOptions {
  handleImmediately?: boolean
}
